import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '../lib/apiClient';
import { lotFromApi, type LotsListResponse } from '../lib/lots';
import type { Lot } from '../data/mockLots';

const LIST_STALE_MS = 5_000;
const LIVE_REFETCH_MS = 4_000;

export type LotsBuckets = {
  live: Lot[];
  scheduled: Lot[];
};

async function fetchDefaultBuckets(): Promise<LotsBuckets> {
  const res = await api.get<LotsListResponse>('/api/lots');
  const live: Lot[] = [];
  const scheduled: Lot[] = [];
  for (const item of res.lots) {
    const lot = lotFromApi(item);
    if (item.status === 'live') live.push(lot);
    else if (item.status === 'scheduled') scheduled.push(lot);
  }
  return { live, scheduled };
}

async function fetchClosedLots(): Promise<Lot[]> {
  const res = await api.get<LotsListResponse>('/api/lots?status=closed');
  return res.lots.map(lotFromApi);
}

export function useLots(): UseQueryResult<LotsBuckets> {
  return useQuery({
    queryKey: ['lots', 'default'],
    queryFn: fetchDefaultBuckets,
    staleTime: LIST_STALE_MS,
    refetchInterval: LIVE_REFETCH_MS,
  });
}

export function useClosedLots(): UseQueryResult<Lot[]> {
  return useQuery({
    queryKey: ['lots', 'closed'],
    queryFn: fetchClosedLots,
    staleTime: 60_000,
  });
}
